import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type CourseCalendarEditor from "cc-frontend/services/course-calendar-editor"
import type Dialog from "cc-frontend/services/dialog"
import type EmberStore from "cc-frontend/services/ember-store"
import { toDown, toLeft, toRight, toUp } from "ember-animated/transitions/move-over"
import _ from "lodash"

let headerNameStack: Array<string> = []
let bodyNameStack: Array<string> = []

@tagName("")
export default class DayMenu extends Component {
  // Args
  planbook!: Planbook
  courses!: Array<Course>
  rotationCalendar!: RotationCalendar
  routine!: CardStack
  closeMenu!: Function
  isOff!: boolean
  dateString!: string
  isFilteringClasses!: boolean
  unitId!: string
  hiddenCourseIds: Array<string> = []
  dayCount!: number

  // Real state
  menuName: string = "PRIMARY"

  // Services
  @service("ember-store") store!: EmberStore
  @service dialog!: Dialog
  @service courseCalendarEditor!: CourseCalendarEditor

  // Ember-animated related stuff
  headerNameStack = ["planner/menus/day-menu/primary/title"]
  bodyNameStack = ["planner/menus/day-menu/primary/body"]

  headerAnimationRules({ oldItems, newItems }) {
    let newVal = newItems[0]
    let oldVal = oldItems[0]
    if (oldVal === undefined || oldVal === null) return toUp
    if (newVal === undefined || newVal === null) return toUp
    let newValInner = Object.getOwnPropertySymbols(newVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )!
    let oldValInner = Object.getOwnPropertySymbols(oldVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )!
    let newComponentName = newVal[newValInner].name
    let oldComponentName = oldVal[oldValInner].name

    // we're going backwards
    if (
      _.includes(headerNameStack, newComponentName) &&
      _.includes(headerNameStack, oldComponentName)
    ) {
      _.pull(headerNameStack, oldComponentName)
      return toDown
    } else {
      headerNameStack.push(newComponentName)
      return toUp
    }
  }

  animationRules({ oldItems, newItems }) {
    let newVal = newItems[0]
    let oldVal = oldItems[0]
    if (oldVal === undefined || oldVal === null) return toLeft
    if (newVal === undefined || newVal === null) return toLeft
    let newValInner = Object.getOwnPropertySymbols(newVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )!
    let oldValInner = Object.getOwnPropertySymbols(oldVal).find(
      (s) => s.toString() === "Symbol(INNER)"
    )!
    let newComponentName = newVal[newValInner].name
    let oldComponentName = oldVal[oldValInner].name

    // For the first check, there's an odd case where the new is null and then the new is present and the old is null
    // and this just makes sure we're always going the right way if we're returning home.
    if (
      newComponentName === "planner/menus/day-menu/primary/body" ||
      (_.includes(bodyNameStack, newComponentName) && _.includes(bodyNameStack, oldComponentName))
    ) {
      // we're going backwards
      _.pull(bodyNameStack, oldComponentName)
      return toRight
    } else {
      bodyNameStack.push(newComponentName)
      bodyNameStack = _.uniq(bodyNameStack)
      return toLeft
    }
  }

  @action
  goToMenu(menuName) {
    this.set("menuName", menuName)
  }

  @action
  backToPrimaryMenu() {
    this.set("menuName", "PRIMARY")
  }

  @action
  addNoSchoolDay() {
    this.set("menuName", "NO_SCHOOL_DAY")
    return
  }
  @action
  addSpecialEvent() {
    this.set("menuName", "ADD_SPECIAL_EVENT")
    return
  }

  @action
  changeStartOfSchoolYear() {
    this.set("menuName", "CHANGE_START_OF_SCHOOL_YEAR")
  }
  @action
  changeEndOfSchoolYear() {
    this.set("menuName", "CHANGE_END_OF_SCHOOL_YEAR")
  }
}
